import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const searchHomeowners = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL, true).get(`/apiv1/global-search/homeowners?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchWorkOrders = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL, true).get(`/apiv1/global-search/work-orders?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchRequestForService = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL, true).get(`/apiv1/global-search/request-for-services?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Search/api.js